import React, { useState, useEffect } from 'react'
import Table from '../../components/Table'
import { jobService } from '../../services/job.service'
import { JobDto } from '@ivy-monorepo/shared'

const REFRESH_INTERVAL = 10000 // 10 seconds

const JobsPage = () => {
  const [jobs, setJobs] = useState<JobDto[] | undefined>(undefined)

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await jobService.getJobs()
        setJobs(response)
      } catch (err) {
        console.log('Failed to fetch jobs', err)
      }
    }

    fetchJobs()
    const interval = setInterval(fetchJobs, REFRESH_INTERVAL)
    return () => clearInterval(interval)
  }, [])

  return (
    <div>
      <div className="jobs-container">
        <h2>Scheduled jobs</h2>
        <Table
          id="jobs"
          name="Jobs"
          keyField="publicId"
          initialSortColumn="nextRunAt"
          columns={[
            { label: ``, accessor: '', type: 'hidden' },
            { label: `Name`, accessor: 'name' },
            { label: `Status`, accessor: 'status', type: 'enum', enumName: 'JobStatus' },
            { label: `Interval`, accessor: 'interval', type: 'interval' },
            { label: `Timeout`, accessor: 'timeout', type: 'interval' },
            { label: `Next run`, accessor: 'nextRunAt', type: 'timeAgo' },
          ]}
          sourceData={jobs || []}
          isPropertyBarVisible={false}
          filterTerms=""
          onRowClick={() => {}}
        />
      </div>
    </div>
  )
}

export default JobsPage
